import React from 'react';
import AspectContainer from "../../../../bootstrap/components/aspect-container/AspectContainer";

function findIframeEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'IFRAME'
            );
        },
        callback
    );
}

const Iframe = (props) => {
    const data = props.contentState.getEntity(props.entityKey).getData();

    return <figure className="iframe-atomic-block">
        <AspectContainer ratio={data.width / data.height}>
            <iframe src={data.src} title={data.title}/>
        </AspectContainer>
        <figcaption>{data.title}</figcaption>
    </figure>;
};

export default {
    strategy: findIframeEntities,
    component: Iframe,
};
